import { render, staticRenderFns } from "./StudentsFilter.vue?vue&type=template&id=a39d7fd6&scoped=true&"
import script from "./StudentsFilter.vue?vue&type=script&lang=js&"
export * from "./StudentsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39d7fd6",
  null
  
)

export default component.exports